function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.every.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useEffect } from 'react';
import { formatDate } from "../../../util/datetime";
import { ACCEPTED_STATUS, ApplicationRelationshipType, CANCELLED_STATUS, DEFERRAL_IN_PROGRESS_STATUS, ENROLLMENT_CONFIRMED_STATUS, NOT_PAID_STATUS, PROCESSING_STATUS, PROGRAM_CLOSED_STATUS, READY_TO_ENROLL_STATUS, REFUND_IN_PROGRESS_STATUS, REJECTED_STATUS, SUBMITTED_STATUS, VERIFICATION_PENDING_STATUS, WAITLISTED_STATUS, WITHDRAWN_STATUS } from "../../../constants/consts";
import raiseErrorMessage from "../../../util/raiseErrorMessage";
var getStatus = function getStatus(applicationAttributes, payment) {
  var accepted = applicationAttributes.accepted,
    canceled = applicationAttributes.canceled,
    deferral_in_progress = applicationAttributes.deferral_in_progress,
    enrollment_confirmed = applicationAttributes.enrollment_confirmed,
    paid = applicationAttributes.paid,
    processing = applicationAttributes.processing,
    program_closed = applicationAttributes.program_closed,
    ready_to_enroll = applicationAttributes.ready_to_enroll,
    refund_in_progress = applicationAttributes.refund_in_progress,
    rejected = applicationAttributes.rejected,
    submitted = applicationAttributes.submitted,
    waitlisted = applicationAttributes.waitlisted,
    withdrawn = applicationAttributes.withdrawn;
  var result = [];
  if (accepted && !refund_in_progress && !deferral_in_progress && !enrollment_confirmed && !ready_to_enroll) {
    result.push(ACCEPTED_STATUS);
  }
  if (rejected) result.push(REJECTED_STATUS);
  if (canceled) result.push(CANCELLED_STATUS);
  if (withdrawn) result.push(WITHDRAWN_STATUS);
  if (refund_in_progress) result.push(REFUND_IN_PROGRESS_STATUS);
  if (deferral_in_progress) result.push(DEFERRAL_IN_PROGRESS_STATUS);
  if (waitlisted) result.push(WAITLISTED_STATUS);
  if (program_closed) result.push(PROGRAM_CLOSED_STATUS);
  if (!withdrawn) {
    if (enrollment_confirmed) {
      result.push(ENROLLMENT_CONFIRMED_STATUS);
    } else if (ready_to_enroll) {
      result.push(READY_TO_ENROLL_STATUS);
    }
  }
  if (paid && processing) {
    result.push(submitted ? SUBMITTED_STATUS : PROCESSING_STATUS);
  } else if ((payment === null || payment === void 0 ? void 0 : payment.payment_method) === 'Manual') {
    result.push(VERIFICATION_PENDING_STATUS);
  } else if (!paid) {
    result.push(NOT_PAID_STATUS);
  }
  return result;
};
var getRequirementCounts = function getRequirementCounts(reqCountsAttributes) {
  if (!reqCountsAttributes) return;
  if (Object.keys(reqCountsAttributes).every(function (key) {
    return reqCountsAttributes[key] === 0;
  })) {
    return 'None Outstanding';
  }
  return [reqCountsAttributes.status_missing || 0, reqCountsAttributes.status_reviewing || 0, reqCountsAttributes.status_not_approved || 0, reqCountsAttributes.status_completed || 0];
};
var getFormatApplicationsData = function getFormatApplicationsData(apiData, reqCounts, isApiDataLoading, isReqCountsLoading, gridApi, gridColumnApi, paginationAttributes, setPaginationAttributes, apiResultCount, isApiCountLoading) {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(function () {
    if (!gridApi || !gridColumnApi) return;
    var isLoading = isApiDataLoading || isReqCountsLoading || isApiCountLoading;
    var isEmpty = !apiData || apiData.data.length === 0;
    if (isLoading) {
      gridApi.showLoadingOverlay();
    } else if (isEmpty) {
      setEmptyData(gridApi);
    } else {
      gridApi.hideOverlay();
    }
    if (isEmpty) {
      return;
    }
    try {
      var includedData = apiData === null || apiData === void 0 ? void 0 : apiData.included; // eslint-disable-line @typescript-eslint/no-explicit-any

      var includedDataMap = includedData.reduce(function (acc, curr) {
        acc["".concat(curr.type, "-").concat(curr.id)] = curr;
        return acc;
      }, {} // eslint-disable-line @typescript-eslint/no-explicit-any
      );

      /**
       * Gets a record from the `included` array in the api response.  Looks up
       * the record by ID and type.  It uses a pre-computed object map so
       * lookups are O(1).  This should be faster than doing loops inside loops
       */
      var getIncludedRecordById = function getIncludedRecordById(params) {
        if (!params.id || !params.type) {
          return undefined;
        }
        return includedDataMap["".concat(params.type, "-").concat(params.id)];
      };
      var data = apiData.data.map(function (application) {
        var _application$attribut, _application$relation, _application$relation2, _application$attribut2, _application$attribut3, _getIncludedRecordByI, _personalInfo$relatio, _program$relationship, _program$relationship2, _includedData$find, _includedData$find$re, _includedData$find$re2, _includedData$find2, _includedData$find3, _application$relation5, _application$relation6, _agentInformation$rel, _includedData$find4, _includedData$find4$r, _includedData$find5, _includedData$find5$r, _includedData$find6, _includedData$find6$a, _application$relation7, _applicationOrderItem, _applicationOrderItem2, _ref, _reqCounts$data, _reqCounts$data$find, _application$relation8, _includedData$find7, _application$relation9, _application$relation10;
        var dataAttributes = application.attributes;

        // payment date
        var paymentDate = formatDate((_application$attribut = application.attributes) === null || _application$attribut === void 0 ? void 0 : _application$attribut.paid_at, 'YYYY-MM-DD');

        // application id
        var appId = application.id;

        // student id
        var userId = (_application$relation = application.relationships) === null || _application$relation === void 0 ? void 0 : (_application$relation2 = _application$relation.user.data) === null || _application$relation2 === void 0 ? void 0 : _application$relation2.id;

        // apply date
        var applyDate = formatDate((_application$attribut2 = application.attributes) === null || _application$attribut2 === void 0 ? void 0 : _application$attribut2.created_at, 'YYYY-MM-DD');

        // conditional acceptance
        var conditionalAcceptance = (_application$attribut3 = application.attributes) === null || _application$attribut3 === void 0 ? void 0 : _application$attribut3.conditional_acceptance;

        // first name, last name, birth date and nationality
        var personalInfo = includedData.find(function (included) {
          var _included$relationshi;
          return included.type === ApplicationRelationshipType.PERSONAL_INFORMATION && ((_included$relationshi = included.relationships) === null || _included$relationshi === void 0 ? void 0 : _included$relationshi.user.data.id) === userId;
        });

        // residence
        var residenceCountry = (_getIncludedRecordByI = getIncludedRecordById({
          id: personalInfo === null || personalInfo === void 0 ? void 0 : (_personalInfo$relatio = personalInfo.relationships.address.data) === null || _personalInfo$relatio === void 0 ? void 0 : _personalInfo$relatio.id,
          type: ApplicationRelationshipType.ADDRESS
        })) === null || _getIncludedRecordByI === void 0 ? void 0 : _getIncludedRecordByI.attributes.country;

        // program
        var program = includedData.find(function (included) {
          var _application$relation3, _application$relation4;
          return included.type === ApplicationRelationshipType.PROGRAM && included.id === ((_application$relation3 = application.relationships) === null || _application$relation3 === void 0 ? void 0 : (_application$relation4 = _application$relation3.program.data) === null || _application$relation4 === void 0 ? void 0 : _application$relation4.id);
        });
        var programId = program === null || program === void 0 ? void 0 : program.id;
        var programName = program === null || program === void 0 ? void 0 : program.attributes.name;

        // school
        var schoolId = program === null || program === void 0 ? void 0 : (_program$relationship = program.relationships.school) === null || _program$relationship === void 0 ? void 0 : (_program$relationship2 = _program$relationship.data) === null || _program$relationship2 === void 0 ? void 0 : _program$relationship2.id;
        var school = includedData.find(function (included) {
          return included.type === ApplicationRelationshipType.SCHOOL && included.id === schoolId;
        });
        var schoolName = school === null || school === void 0 ? void 0 : school.attributes.name;
        var schoolCountryFlag = school === null || school === void 0 ? void 0 : school.attributes.flag;

        // rp email
        var rpId = (_includedData$find = includedData.find(function (included) {
          return included.type === ApplicationRelationshipType.USER && included.id === userId;
        })) === null || _includedData$find === void 0 ? void 0 : (_includedData$find$re = _includedData$find.relationships.agent) === null || _includedData$find$re === void 0 ? void 0 : (_includedData$find$re2 = _includedData$find$re.data) === null || _includedData$find$re2 === void 0 ? void 0 : _includedData$find$re2.id;
        var rpEmail = (_includedData$find2 = includedData.find(function (included) {
          return included.type === ApplicationRelationshipType.USER && included.id === rpId;
        })) === null || _includedData$find2 === void 0 ? void 0 : _includedData$find2.attributes.email;
        var rpName = (_includedData$find3 = includedData.find(function (included) {
          return included.type === ApplicationRelationshipType.USER && included.id === rpId;
        })) === null || _includedData$find3 === void 0 ? void 0 : _includedData$find3.attributes.full_name;

        // recruiter type
        var agentInformation = includedData.find(function (included) {
          var _included$relationshi2;
          return included.type === ApplicationRelationshipType.AGENT_INFORMATION && (included === null || included === void 0 ? void 0 : (_included$relationshi2 = included.relationships.user.data) === null || _included$relationshi2 === void 0 ? void 0 : _included$relationshi2.id) === rpId;
        });
        var isAgencyStaff = agentInformation === null || agentInformation === void 0 ? void 0 : agentInformation.attributes.agency_staff;
        var recruiterType = typeof isAgencyStaff === 'boolean' && (isAgencyStaff ? 'Staff' : 'Owner') || undefined;

        // original irm
        var originalIrmId = (_application$relation5 = application.relationships) === null || _application$relation5 === void 0 ? void 0 : (_application$relation6 = _application$relation5.original_sales_representative_agent.data) === null || _application$relation6 === void 0 ? void 0 : _application$relation6.id;
        var originalIrmUser = includedData.find(function (included) {
          var _included$relationshi3, _included$relationshi4, _included$relationshi5;
          return originalIrmId && included.type === ApplicationRelationshipType.USER && ((_included$relationshi3 = included.relationships) === null || _included$relationshi3 === void 0 ? void 0 : (_included$relationshi4 = _included$relationshi3.agent_manager) === null || _included$relationshi4 === void 0 ? void 0 : (_included$relationshi5 = _included$relationshi4.data) === null || _included$relationshi5 === void 0 ? void 0 : _included$relationshi5.id) === originalIrmId;
        });
        var originalIrmData = (originalIrmUser === null || originalIrmUser === void 0 ? void 0 : originalIrmUser.attributes.full_name) || (originalIrmUser === null || originalIrmUser === void 0 ? void 0 : originalIrmUser.attributes.email);

        // current irm
        var agentManagerId = agentInformation === null || agentInformation === void 0 ? void 0 : (_agentInformation$rel = agentInformation.relationships.agent_manager.data) === null || _agentInformation$rel === void 0 ? void 0 : _agentInformation$rel.id;
        var agentManagerUser = includedData.find(function (included) {
          var _included$relationshi6, _included$relationshi7, _included$relationshi8;
          return agentManagerId && included.type === ApplicationRelationshipType.USER && ((_included$relationshi6 = included.relationships) === null || _included$relationshi6 === void 0 ? void 0 : (_included$relationshi7 = _included$relationshi6.agent_manager) === null || _included$relationshi7 === void 0 ? void 0 : (_included$relationshi8 = _included$relationshi7.data) === null || _included$relationshi8 === void 0 ? void 0 : _included$relationshi8.id) === agentManagerId;
        });
        var agentManagerData = (agentManagerUser === null || agentManagerUser === void 0 ? void 0 : agentManagerUser.attributes.full_name) || (agentManagerUser === null || agentManagerUser === void 0 ? void 0 : agentManagerUser.attributes.email);

        // student support officer
        var studentSalesRepId = (_includedData$find4 = includedData.find(function (included) {
          var _included$relationshi9;
          return included.type === ApplicationRelationshipType.STUDENT_INFORMATION && (included === null || included === void 0 ? void 0 : (_included$relationshi9 = included.relationships.user.data) === null || _included$relationshi9 === void 0 ? void 0 : _included$relationshi9.id) === userId;
        })) === null || _includedData$find4 === void 0 ? void 0 : (_includedData$find4$r = _includedData$find4.relationships.sales_representative.data) === null || _includedData$find4$r === void 0 ? void 0 : _includedData$find4$r.id;
        var studentSalesRepUserId = (_includedData$find5 = includedData.find(function (included) {
          return included.type === ApplicationRelationshipType.SALES_REPRESENTATIVE && included.id === studentSalesRepId;
        })) === null || _includedData$find5 === void 0 ? void 0 : (_includedData$find5$r = _includedData$find5.relationships.user.data) === null || _includedData$find5$r === void 0 ? void 0 : _includedData$find5$r.id;
        var studentSalesRepFullName = (_includedData$find6 = includedData.find(function (included) {
          return included.type === ApplicationRelationshipType.USER && included.id === studentSalesRepUserId;
        })) === null || _includedData$find6 === void 0 ? void 0 : (_includedData$find6$a = _includedData$find6.attributes) === null || _includedData$find6$a === void 0 ? void 0 : _includedData$find6$a.full_name;

        // orders and payments
        var orderItemId = (_application$relation7 = application.relationships.order_item.data) === null || _application$relation7 === void 0 ? void 0 : _application$relation7.id;
        var applicationOrderItem = getIncludedRecordById({
          id: orderItemId,
          type: ApplicationRelationshipType.ORDER_ITEM
        });
        var isFree = typeof (applicationOrderItem === null || applicationOrderItem === void 0 ? void 0 : (_applicationOrderItem = applicationOrderItem.attributes) === null || _applicationOrderItem === void 0 ? void 0 : _applicationOrderItem.price) !== 'undefined' && Number(applicationOrderItem.attributes.price) === 0;
        var orderId = applicationOrderItem === null || applicationOrderItem === void 0 ? void 0 : (_applicationOrderItem2 = applicationOrderItem.relationships.order.data) === null || _applicationOrderItem2 === void 0 ? void 0 : _applicationOrderItem2.id;
        var payments = includedData.filter(function (included) {
          var _included$relationshi10;
          return included.type === ApplicationRelationshipType.PAYMENT && (included === null || included === void 0 ? void 0 : (_included$relationshi10 = included.relationships.order.data) === null || _included$relationshi10 === void 0 ? void 0 : _included$relationshi10.id) === orderId;
        }).sort(function (a, b) {
          return Number(a.id) - Number(b.id);
        });
        var firstPaymentAttributes = (_ref = payments.find(function (payment) {
          return payment.attributes.payment_method === ApplicationRelationshipType.MANUAL_PAYMENT;
        }) || payments[0]) === null || _ref === void 0 ? void 0 : _ref.attributes;

        // status
        var status = getStatus(dataAttributes, firstPaymentAttributes);

        // requirement counts
        var requirementCounts = getRequirementCounts(reqCounts === null || reqCounts === void 0 ? void 0 : (_reqCounts$data = reqCounts.data) === null || _reqCounts$data === void 0 ? void 0 : (_reqCounts$data$find = _reqCounts$data.find(function (count) {
          return count.id === appId;
        })) === null || _reqCounts$data$find === void 0 ? void 0 : _reqCounts$data$find.attributes);

        // current stage
        var currentStageId = (_application$relation8 = application.relationships.current_stage.data) === null || _application$relation8 === void 0 ? void 0 : _application$relation8.id;
        var currentStage = (_includedData$find7 = includedData.find(function (included) {
          return included.type === ApplicationRelationshipType.APPLICATION_STAGE && included.id === currentStageId;
        })) === null || _includedData$find7 === void 0 ? void 0 : _includedData$find7.attributes.label;
        var applicationServiceFeeChargeIds = ((_application$relation9 = application.relationships) === null || _application$relation9 === void 0 ? void 0 : (_application$relation10 = _application$relation9.application_service_fee_charges) === null || _application$relation10 === void 0 ? void 0 : _application$relation10.data) || [];
        var applicationServiceFeeCharges = applicationServiceFeeChargeIds.map(function (dataItem) {
          var _applicationServiceFe, _applicationServiceFe2, _applicationServiceFe3, _applicationServiceFe4, _applicationServiceFe5, _applicationServiceFe6, _correspondingOrderIt, _correspondingOrderIt2;
          var applicationServiceFeeCharge = getIncludedRecordById({
            id: dataItem.id,
            type: ApplicationRelationshipType.APPLICATION_SERVICE_FEE_CHARGE
          });
          if (!applicationServiceFeeCharge) {
            return undefined;
          }
          var correspondingOrderItem = getIncludedRecordById({
            id: (_applicationServiceFe = applicationServiceFeeCharge.relationships) === null || _applicationServiceFe === void 0 ? void 0 : (_applicationServiceFe2 = _applicationServiceFe.order_item) === null || _applicationServiceFe2 === void 0 ? void 0 : (_applicationServiceFe3 = _applicationServiceFe2.data) === null || _applicationServiceFe3 === void 0 ? void 0 : _applicationServiceFe3.id,
            type: ApplicationRelationshipType.ORDER_ITEM
          });
          var correspondingApplicationServiceFee = getIncludedRecordById({
            id: (_applicationServiceFe4 = applicationServiceFeeCharge.relationships) === null || _applicationServiceFe4 === void 0 ? void 0 : (_applicationServiceFe5 = _applicationServiceFe4.application_service_fee) === null || _applicationServiceFe5 === void 0 ? void 0 : (_applicationServiceFe6 = _applicationServiceFe5.data) === null || _applicationServiceFe6 === void 0 ? void 0 : _applicationServiceFe6.id,
            type: ApplicationRelationshipType.APPLICATION_SERVICE_FEE
          });
          var hasFeeWaiver = Boolean(correspondingOrderItem === null || correspondingOrderItem === void 0 ? void 0 : (_correspondingOrderIt = correspondingOrderItem.relationships) === null || _correspondingOrderIt === void 0 ? void 0 : (_correspondingOrderIt2 = _correspondingOrderIt.order_item_fee_waiver) === null || _correspondingOrderIt2 === void 0 ? void 0 : _correspondingOrderIt2.data);
          var oncePerStudent = Boolean(correspondingApplicationServiceFee === null || correspondingApplicationServiceFee === void 0 ? void 0 : correspondingApplicationServiceFee.attributes.once_per_student);
          return {
            id: applicationServiceFeeCharge.id,
            formatted_price: applicationServiceFeeCharge.attributes.formatted_price,
            title: applicationServiceFeeCharge.attributes.title,
            cancelled: applicationServiceFeeCharge.attributes.cancelled,
            has_fee_waiver: hasFeeWaiver,
            once_per_student: oncePerStudent
          };
        }).filter(Boolean);

        // TODO: add permissions for certain columns
        return _objectSpread(_objectSpread(_objectSpread({}, application.attributes), {}, {
          payment_date: paymentDate,
          app_id: appId,
          student_id: userId,
          apply_date: applyDate
        }, personalInfo === null || personalInfo === void 0 ? void 0 : personalInfo.attributes), {}, {
          program: programName,
          program_id: programId,
          school: schoolName,
          school_id: schoolId,
          school_country_flag: schoolCountryFlag,
          residence: residenceCountry,
          recruitment_partner: rpEmail,
          rp_id: rpId,
          recruitment_partner_name: rpName,
          recruiter_type: recruiterType,
          original_irm: originalIrmData,
          current_irm: agentManagerData,
          student_support_officer: studentSalesRepFullName,
          status: status,
          requirements: requirementCounts,
          current_stage: currentStage,
          conditional_acceptance: conditionalAcceptance,
          application_service_fee_charges: applicationServiceFeeCharges,
          is_free: isFree
        });
      });

      // starting updating pagination
      var totalCount = data.length;
      var totalPages = 1;
      if (apiResultCount) {
        var _apiResultCount$data, _apiResultCount$data$;
        totalCount = ((_apiResultCount$data = apiResultCount.data) === null || _apiResultCount$data === void 0 ? void 0 : (_apiResultCount$data$ = _apiResultCount$data.attributes) === null || _apiResultCount$data$ === void 0 ? void 0 : _apiResultCount$data$.total_count) || 1;
        totalPages = Math.max(Math.ceil(totalCount / paginationAttributes.pageSize), 1);
      } else if (data.length > paginationAttributes.pageSize) {
        // I really don't like this solution but we need a way to indicate
        // more pages are available when total count isn't available
        totalCount = data.length + paginationAttributes.pageSize * paginationAttributes.pageNumber;
        totalPages = paginationAttributes.pageNumber + 1;
      }
      setPaginationAttributes(_objectSpread(_objectSpread({}, paginationAttributes), {}, {
        totalPages: totalPages,
        totalCount: totalCount
      }));
      // done updating pagination

      if (data.length > paginationAttributes.pageSize) {
        data = data.slice(0, paginationAttributes.pageSize);
      }
      gridApi.setRowData(data);
    } catch (e) {
      gridApi.hideOverlay();
      console.error('error caught', e);
      raiseErrorMessage('Unable to set table data');
    }
  }, [apiData, isApiDataLoading, isReqCountsLoading, gridApi, gridColumnApi, setPaginationAttributes, apiResultCount, isApiCountLoading]);
};
function setEmptyData(gridApi) {
  // This line is needed to hide the loading state.  According to the
  // documentation, `setRowData` is supposed to hide the loading state when
  // called, but it doesn't
  //
  // > When the API function setRowData is called, the loading panel is hidden.
  //
  // See: https://www.ag-grid.com/javascript-grid/overlays/#overlay-api
  // Also see: https://applyboard.atlassian.net/browse/HRM-87
  gridApi.hideOverlay();

  // Clears any existing rows
  gridApi.setRowData(null);

  // According to this ag-grid issue:
  //
  // https://github.com/ag-grid/ag-grid/issues/1665#issuecomment-303974505
  //
  // `setRowData` is supposed to automatically show the "no rows" overlay when
  // called with `null`.  But it doesn't here. So we need to call
  // `showNoRowsOverlay` explicitly.  However, ag-grid seems to ignore
  // `showNoRowsOverlay` when `setRowData` is called before it on the same event
  // loop tick.  So setTimeout is used as a workaround
  setTimeout(function () {
    // Check the row count incase it has changed during a previous event loop ticket
    if (gridApi.getDisplayedRowCount() === 0) {
      gridApi.showNoRowsOverlay();
    }
  }, 0);
}
export default getFormatApplicationsData;